import { render, staticRenderFns } from "./my-about-us.vue?vue&type=template&id=63f64825&scoped=true"
import script from "./my-about-us.vue?vue&type=script&lang=js"
export * from "./my-about-us.vue?vue&type=script&lang=js"
import style0 from "./my-about-us.vue?vue&type=style&index=0&id=63f64825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f64825",
  null
  
)

export default component.exports